import { defineMessages } from 'react-intl-next';

export const i18n = defineMessages({
	clearFilters: {
		id: 'search-page.filters.clear-filters-button-label',
		defaultMessage: 'Clear filters',
	},
	suggestedFilters: {
		id: 'search-page.filters.suggested-filters-section-label',
		defaultMessage: 'Suggested',
	},
});
